import React from 'react';
import {Button} from 'src/ui-components/Button/button';
import Mic from '../../assets/icons/mic.svg';
import {Dialog, DialogContent, DialogTrigger} from 'src/ui-components/Modal';
import UserReferral from 'src/components/user-referral/UserReferral';
import {ReferralCodeInterface} from 'src/reducers/users';
import Tracker from 'src/lib/analytics/tracker';
import {EventNames} from 'src/lib/analytics/events';

export default function Referral(props: {code: ReferralCodeInterface; referralCount: number}) {
    return (
        <section>
            <Dialog>
                <div
                    className='flex items-center justify-between rounded-[8px]
            bg-gradient-to-r from-[#ACCBEE] to-[#E7F0FD]'>
                    <div className='flex flex-col px-[9px] pb-[6px] pt-[7px]'>
                        <h3 className=' text-[11.5px] font-[400] text-[#000000]'>
                            Get <span className='font-[700]'>2 GB</span> on referring a friend
                        </h3>
                        <div className='pt-[6px]'>
                            <DialogTrigger asChild>
                                <Button
                                    variant='secondary'
                                    size='sm'
                                    onClick={() => {
                                        Tracker.trackEvent(EventNames.REFER_CLICKED);
                                    }}>
                                    Refer Now
                                </Button>
                            </DialogTrigger>
                        </div>
                    </div>
                    <div className='pr-[11px] pt-[20px]'>
                        <img src={Mic} alt='Microphone' height={46} width={56} />
                    </div>
                </div>
                <DialogContent className='w-[972px]'>
                    <UserReferral code={props.code} referralCount={props.referralCount} />
                </DialogContent>
            </Dialog>
        </section>
    );
}
